import React from "react";
import { Typography } from '@progress/kendo-react-common';

function escapeRegex(str) {
    return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

/**
 * InlineText with case-insensitive highlight
 *
 * @param {object} props
 * @param {string} props.text - The text to render.
 * @param {string} props.highlight - Substring to highlight (case-insensitive).
 * @param {"bold"|"normal"|"light"} props.fontWeight
 * @param {"center"|"left"|"right"|"justify"} props.textAlign
 * @param {object} [props.style] - Additional inline styles.
 */
export const HighlightedText = ({
                                    text = '',
                                    highlight = '',
                                    style = {},
                                    ...typographyProps
                                }) => {
    const styleInline = { display: 'inline', padding: 0, margin: 0, ...style };

    // Convert text to string and handle null/undefined cases
    const textStr = text != null ? String(text) : '';
    const highlightStr = highlight != null ? String(highlight) : '';

    if (!highlightStr) {
        return (
            <Typography.p {...typographyProps} style={styleInline}>
                {textStr}
            </Typography.p>
        );
    }

    const escaped = escapeRegex(highlightStr);
    const regex = new RegExp(`(${escaped})`, 'gi');
    const parts = textStr.split(regex);

    return (
        <Typography.p {...typographyProps} style={styleInline}>
            {parts.map((part, i) => {
                if (!part) return null; // Skip empty parts

                // Check if this part matches the highlight (case-insensitive)
                const isMatch = part.toLowerCase() === highlightStr.toLowerCase();

                return isMatch ? (
                    <mark key={i}>{part}</mark>
                ) : (
                    <span key={i}>{part}</span>
                );
            }).filter(Boolean)} {/* Remove null values */}
        </Typography.p>
    );
};